import { render, staticRenderFns } from "./mentor_index.vue?vue&type=template&id=3dbd6f3e&scoped=true"
import script from "./mentor_index.vue?vue&type=script&lang=js"
export * from "./mentor_index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/doctor-detail.css?vue&type=style&index=0&id=3dbd6f3e&prod&scoped=true&lang=css&external"
import style1 from "../../assets/css/case_management.css?vue&type=style&index=1&id=3dbd6f3e&prod&scoped=true&lang=css&external"
import style2 from "./mentor_index.vue?vue&type=style&index=2&id=3dbd6f3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd6f3e",
  null
  
)

export default component.exports